"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UALLoggedInAuthType = 'UALLoggedInAuthType';
exports.UALAccountName = 'UALAccountName';



//////////////////
// WEBPACK FOOTER
// ./node_modules/_universal-authenticator-library@0.3.0@universal-authenticator-library/dist/interfaces.js
// module id = 93BM
// module chunks = 1